// extracted by mini-css-extract-plugin
export var inverse = "logo-module--inverse--397e2";
export var small = "logo-module--small--e9f01";
export var wrapper = "logo-module--wrapper--7a957";